// import logo from './logo.svg';
import './App.css';
import Footer from './component/Footer';
import Todo from './component/todo';
// import Footer from './component/Footer';

function App() {
  return (
    <div className="App">
      <Todo/>
      <Footer/>
    </div>
  );
}

export default App;
